import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			flexGrow: 1,
		},
		menuButton: {
			margin: 0,
			padding: '0.5rem 0 0 .8rem',
			color: '#a22f00',
			borderTopLeftRadius: '30rem',
			borderBottomLeftRadius: 20,
		},
		title: {
			flexGrow: 1,
		},
		header: {
			background: '#fff1bd',
			border: 'none !important',
			color: 'white !important',
			padding: '0 1rem !important',
		},
		styledMenuItem: {
			padding: '1rem 3rem',
		},
		logout: {
			display: 'flex',
			background: 'white !important',
			boxShadow: 'none',
			color: '#67AEB3',
			fontFamily: 'Poppins',
			fontSize: '14px',
		},
	}),
);


